export default __webpack_public_path__ + "static/media/bg1.ff86f827.jpg";